import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Componentes
import AppNavbar from './components/Layout/Navbar';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import ConfirmEmail from './components/Auth/ConfirmEmail';
import Dashboard from './components/Dashboard/Dashboard';
import FileUpload from './components/DataUpload/FileUpload';
import PrivateRoute from './components/Common/PrivateRoute';
import AuthService from './services/auth.service';
import Home from './pages/Home';

function App() {
  const isLoggedIn = AuthService.isAuthenticated();
  
  return (
    <Router>
      <div className="App">
        {/* Solo mostrar Navbar cuando NO estamos en la landing page */}
        <Routes>
          <Route path="/" element={null} />
          <Route path="*" element={<AppNavbar />} />
        </Routes>
        <Routes>
          <Route path="/" element={isLoggedIn ? <Navigate to="/dashboard" /> : <Home />} />
          <Route path="/login" element={isLoggedIn ? <Navigate to="/dashboard" /> : <Login />} />
          <Route path="/register" element={isLoggedIn ? <Navigate to="/dashboard" /> : <Register />} />
          <Route path="/confirm/:token" element={<ConfirmEmail />} />
          <Route 
            path="/dashboard" 
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/upload" 
            element={
              <PrivateRoute adminOnly={true}>
                <FileUpload />
              </PrivateRoute>
            } 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
